export default __webpack_public_path__ + "static/media/clear-night.80831c47.svg";